import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getNextAgendasEvents, putNotifyAgendaEvent } from 'services/api';
import { normalizeDataTableAgendas } from './operators';

export interface AgendasState {
  agendaList: {
    data: any,
    dataTableList: any,
    pagination: {
      total: number,
      page: number,
    }
    status: null | 'idle' | 'loading' | 'failed',
  },
  agendaEventNotify: {
    notified: boolean,
    status: null | 'idle' | 'loading' | 'failed',
  }
}

const initialState: AgendasState = {
  agendaList: {
    data: [],
    dataTableList: [],
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
  agendaEventNotify: {
    notified: false,
    status: null,
  }
};

export const getAgendasAsync: any | null = createAsyncThunk(
  'devices/getNextAgendasEvents',
  async (data: any) => {
    const response = await getNextAgendasEvents(data);
    return response?.data;
  }
);

export const putNotifyAgendaEventAsync: any | null = createAsyncThunk(
  'devices/notifyAgendaEvent',
  async (data: any, { dispatch }) => {
    const response = await putNotifyAgendaEvent(data);
    response?.status === 200 && dispatch(getAgendasAsync({ init: 0, size: 10 }));
    return response;
  }
);

export const agendasSlice = createSlice({
  name: 'agendas',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAgendasAsync.pending, (state) => {
        state.agendaList.status = 'loading';
      })
      .addCase(getAgendasAsync.fulfilled, (state, action) => {
        state.agendaList.status = 'idle';
        state.agendaList.data = action.payload;
        state.agendaList.dataTableList = normalizeDataTableAgendas(action.payload)
        state.agendaList.pagination.total = action.payload?.data?.total;
      })
      .addCase(getAgendasAsync.rejected, (state) => {
        state.agendaList.status = 'failed';
      })
      .addCase(putNotifyAgendaEventAsync.pending, (state) => {
        state.agendaEventNotify.status = 'loading';
      })
      .addCase(putNotifyAgendaEventAsync.fulfilled, (state, action) => {
        state.agendaEventNotify.status = 'idle';
        state.agendaEventNotify.notified = action.payload?.data?.success;
      })
      .addCase(putNotifyAgendaEventAsync.rejected, (state) => {
        state.agendaEventNotify.status = 'failed';
      })
  }
});

export default agendasSlice.reducer;
